import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

interface Props {
  userIsLoggedIn: boolean;
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
  [key: string]: any;
}

// tslint:disable-next-line:variable-name
const ProtectedRoute = ({ userIsLoggedIn, component, ...rest }: Props) => {
  // component names have to be PascalCased
  // tslint:disable-next-line:variable-name
  const Comp = component as any;
  return (
    <Route {...rest} render={props => (
      userIsLoggedIn
        ? <Comp  {...props} />
        : <h2>Not authenticated</h2>
    )} />
  );
};

export default ProtectedRoute;
